import React, { useRef, useState } from "react";
import RecordView from "./RecordView";
import OpusMediaRecorder from "opus-media-recorder";
import { Box } from "@material-ui/core";

const SimpleRecorder = (props: any) => {
    // var recorder: OpusMediaRecorder;
    const recorder = useRef<OpusMediaRecorder | null>(null);
    const gumStream = useRef<MediaStream | null>(null);
    const [permissao, setPermissao] = useState(false);
    const workerOptions = {
        encoderWorkerFactory: function () {
            return new Worker(
                process.env.PUBLIC_URL +
                    "/opus-media-recorder/encoderWorker.umd.js"
            );
        },
        OggOpusEncoderWasmPath:
            process.env.PUBLIC_URL + "/opus-media-recorder/OggOpusEncoder.wasm",
        WebMOpusEncoderWasmPath:
            process.env.PUBLIC_URL +
            "/opus-media-recorder/WebMOpusEncoder.wasm",
    };

    const startRecord = async () => {
        try {
            await navigator.mediaDevices
                .getUserMedia({
                    audio: true,
                })
                .then(function (stream) {
                    setPermissao(true);
                    const options = { mimeType: "audio/ogg" };
                    var oldPreviewElm;
                    oldPreviewElm = document.getElementById("preview");
                    if (oldPreviewElm?.hasChildNodes()) {
                        oldPreviewElm.removeChild(oldPreviewElm.childNodes[0]);
                    }
                    gumStream.current = stream;
                    recorder.current = new OpusMediaRecorder(
                        stream,
                        options,
                        workerOptions
                    );
                    recorder.current.ondataavailable = function (e) {
                        var url = URL.createObjectURL(e.data);
                        var preview = document.createElement("audio");
                        preview.controls = true;
                        preview.src = url;
                        var previewElm;
                        previewElm = document.getElementById("preview");
                        if (previewElm?.hasChildNodes()) {
                            previewElm.replaceChild(
                                preview,
                                previewElm.childNodes[0]
                            );
                        } else {
                            previewElm?.appendChild(preview);
                        }
                        props.saveFileAudio(e.data);
                    };
                    recorder.current.start();
                });
        } catch (error) {
            console.error("Error accessing microphone:", error);
        }
    };
    const pauseRecord = () => {
        recorder.current?.pause();
        setPermissao(false);
    };
    const stopRecord = () => {
        recorder.current?.stop();
        gumStream.current?.getAudioTracks()[0].stop();
    };

    const resumeRecord = () => {
        recorder.current?.resume();
    };

    return (
        <div className="d-flex justify-content-center align-items-center">
            <RecordView
                permissao={permissao}
                startRecord={startRecord}
                pauseRecord={pauseRecord}
                resumeRecord={resumeRecord}
                stopRecord={stopRecord}
            />
            <Box id="preview" className="ml-6" />
        </div>
    );
};

export default SimpleRecorder;
